module.exports = __webpack_public_path__ + "static/media/NimbusSanL-Bold.355985bc.otf";